import {
  Component,
  EventEmitter,
  Injector,
  OnInit,
  Output
} from '@angular/core';
import { BaseComponent } from '../../base.component';
import { RouterLink, RouterLinkActive } from '@angular/router';

/**
 * نوار بالای سایت — فقط ناوبری.
 *
 * ساعت، قیمت لحظه‌ای طلا، نمودار و تصویر هیرو قبلاً همین‌جا بودند و با یک
 * شرط isHomePage تنها در صفحه‌ی اصلی رندر می‌شدند؛ حالا در HomeComponent
 * هستند، یعنی جایی که واقعاً دیده می‌شوند.
 */
@Component({
  selector: 'app-header',
  standalone: true,
  imports: [RouterLink, RouterLinkActive],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss'
})
export class HeaderComponent extends BaseComponent implements OnInit {

  @Output() contactClick = new EventEmitter<void>();

  constructor(injector: Injector) {
    super(injector);
  }

  override ngOnInit() {
    super.ngOnInit();
  }

  onContactClick() {
    this.contactClick.emit();
  }
}
